import React, { useCallback } from 'react';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { UIField, UIFieldProps } from '../../canvas/entities/UIField';
import { BlockWheel } from '../../canvas/tooling/ToolLayer';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { RenderFencedContent } from './RenderFencedContent';
import { TextGenerator, TextGeneratorComplete, TextGeneratorInboundValue } from './TextGenerator';
import { textGeneratorValuePropertyLayout } from './TextGeneratorPropertyLayouts';

export const TextGeneratorValueFieldEditor = ({ active, field }: UIFieldProps) => {

    const objects = useResolve(ObjectManager);
    const object = field.owner.cast(TextGenerator);
    useComponentObserver(object);

    const onChange = useCallback((nextValue: string) => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            object.value = nextValue;
        });
    }, [field]);

    const onCommit = useCallback(() => {

    }, []);

    const value = TextGeneratorInboundValue.get(object);
    const complete = TextGeneratorComplete.get(object);

    return <BlockWheel>
        <Flexer absolute inset={4 / 16}>
            <RenderFencedContent content={value} complete={complete} />
        </Flexer>
    </BlockWheel>;
};

export const TextGeneratorValueField = (owner: TextGenerator): UIField => ({
    ui: TextGeneratorValueFieldEditor,
    name: 'value',
    bounds: owner.layout.value.bounds,
    owner,
    propertyLayout: textGeneratorValuePropertyLayout,
});
